import { render, staticRenderFns } from "./ANxAPxMentalPage.vue?vue&type=template&id=38373eab"
import script from "./ANxAPxMentalPage.vue?vue&type=script&lang=js"
export * from "./ANxAPxMentalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports